import React from 'react';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TableHead,
} from '@mui/material';

interface NoActionTableProps {
  rows: any[];
  columns: any[];
  handleRowClick: (data: any) => void;
  customClick?: (data: any) => void;
  handleStatus: (data: any, event?: any) => void;
}

// Main Custom Table Component
const NoActionTable: React.FC<NoActionTableProps> = ({
  rows,
  columns,
  handleRowClick,
  customClick,
  handleStatus,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
        <TableHead style={{ background: ' rgba(0, 244, 255, 0.06)' }}>
          <TableRow>
            {columns.map((column, indexc) => (
              <TableCell
                key={'tblcell_' + column.field + '_' + indexc}
                style={{}}
              >
                {column.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index: number) => (
            <TableRow
              sx={{ cursor: 'pointer' }}
              key={'tblrowbody_' + index || 'tblrowbody_' + index}
              onClick={(event: any) => {
                const currentClass: any = event.target.className;

                if (event.target.type === 'checkbox') {
                  event.preventDefault();
                  handleStatus(row, event);
                } else {
                  if (typeof currentClass === 'string') {
                    if (currentClass.indexOf('MuiTableCell-root') !== -1) {
                      handleRowClick(row);
                    } else {
                      if (customClick) {
                        customClick(row);
                      }
                    }
                  } else {
                    if (customClick) {
                      customClick(row);
                    }
                  }
                }
              }}
            >
              {columns.map((column, index: any) => (
                <TableCell
                  key={'tblbodycell_' + index + '_' + column.field}
                  style={{ width: column.width ? column.width : 'auto' }}
                >
                  {column.renderCell
                    ? column.renderCell(row[column.field], row)
                    : column.valueGetter
                      ? column.valueGetter(row[column.field], row)
                      : (row[column.field] ?? '-')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NoActionTable;
